import { TranslatePipe } from '../../filters/translate.pipe';
import { CardTherapyFundWalletsComponent } from '../../components/card-therapy-fund-wallets/card-therapy-fund-wallets.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'therapy-fund-wallets',
	templateUrl: './therapy-fund-wallets.component.html',
	imports: [ CommonModule, TranslatePipe, CardTherapyFundWalletsComponent, FormsModule ]
})
export default class TherapyFundWalletsView implements OnInit {
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('therapyFundWallets').then(() => {});
	}
	
}